export enum BookingStatus {
  BOOKING_DRAFT = 'BOOKING_STATUS_BOOKING_DRAFT',
  BOOKING_ORDERED = 'BOOKING_STATUS_BOOKING_ORDERED',
}

export interface Booking {
  id: string
  status: BookingStatus
}
